<template>
  <div class="asset_list">
    <div class="asset_list--heading flex flex-vertical-center">
      <icon-default :icon="icon"></icon-default>
      <h4 class="ml-50">{{ label }}</h4>
    </div>

    <div class="asset_list--list">
      <template v-if="shareableAssets.length">
        <div
          v-for="asset in shareableAssets"
          :key="asset.asset_id"
          class="asset_list--item"
        >
          <form-field-checkbox
            class="asset_list--checklist"
            :label="asset.label"
            :secondary-label="secondaryLabel(asset)"
            v-model="asset.shared"
            label-is-bold
          ></form-field-checkbox>

          <p class="asset_list--description">{{ asset.description }}</p>
        </div>
      </template>
      <p v-else class="asset_list--empty">There are no assets to share</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShareableAssetList",
  props: {
    label: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    shareableAssets: {
      type: Array,
      required: true
    },
    countKey: {
      type: String
    },
    countLabel: {
      type: String
    },
  },
  methods: {
    secondaryLabel(asset) {
      if(this.countKey && this.countLabel) {
        return asset[this.countKey] + ' ' + this.countLabel
      }

      if(this.countKey) {
        return asset[this.countKey]
      }

      return null;
    }
  },
}
</script>

<style lang="scss" scoped>
@import "../../../styles/variables/variables";

.asset_list {
  margin-top: 1.5rem;

  &--heading {
    margin-bottom: 20px;
    font-size: 1.125rem;
    color: $text-light;
  }

  &--list {
    padding-left: 32px;
  }

  &--item {
    margin-bottom: 1.5rem;
  }

  &--checklist {
    margin-bottom: 2px;
  }

  &--description {
    padding-left: 30px;
    line-height: 1.4;
  }

  &--empty {
    margin-bottom: 1rem;
    font-style: italic;
  }
}
</style>
